module.exports = __webpack_public_path__ + "img/img-20.eca98e9b.png";